<template>
  <section>
    <sweet-modal :width="($mq.desktop) ? '500' : '100%'"
                 ref="modal"
                 overlay-theme="dark"
                 @close="checkCloseLoginModal">
      <login-form ref="loginForm" v-if="formType === 'login'" @closeModal="closeModal" @openAppModal="openAppModal"  />
      <register-form v-else-if="formType === 'register'" registerFrom="loginModal"/>
      <reset-password-form v-else-if="formType === 'reset-password'"/>
    </sweet-modal>
    <!-- Login alert -->
    <login-alert ref="loginAlert"/>

    <sweet-modal ref="confirmToLogin">
      <div class="row">
        <div class="col-sm-12">
          {{confirmMessage}}
        </div>
      </div>
      <br>
      <div class="row" v-if="platform === 'facebook'">
        <div class="col-12">
          <button class="button-large button-block button-login -indigo" @click="$refs.loginForm.preLogin('facebook')">
            <i class="fab fa-facebook-f"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_facebook')
            }}</label>
          </button>
        </div>
      </div>

      <div class="row" v-if="platform === 'googleplus'">
        <div class="col-12">
          <button class="button-large button-block button-login -red" @click="$refs.loginForm.preLogin('googleplus')">
            <i class="fab fa-google"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_google') }}</label>
          </button>
        </div>
      </div>

      <div class="row" v-if="platform === 'apple'">
        <div class="col-12">
          <button class="button-large button-block button-login btn-dark" @click="$refs.loginForm.preLogin('apple')">
            <i class="fab fa-apple fa-lg"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_apple') }}</label>
          </button>
        </div>
      </div>

    </sweet-modal>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import LoginAlert from './LoginAlert'
  import LoginForm from './LoginForm'
  import RegisterForm from './RegisterForm'
  import ResetPasswordForm from './ResetPasswordForm'

  export default {
    components: {
      LoginAlert,
      LoginForm,
      RegisterForm,
      ResetPasswordForm,
      SweetModal
    },
    data () {
      return {
        alertMessage: null,
        confirmMessage: null,
        platform: null
      }
    },
    computed: {
      ...mapGetters({
        formType: 'auth/getLoginFormType',
        user: 'auth/getUser'
      })
    },
    methods: {
      confirmLoginThrough (message, platform) {
        this.confirmMessage = message
        this.platform = platform
        this.$refs.confirmToLogin.open()
      },
      showAlertMessage (message) {
        this.$refs.loginAlert.setMessage(message)
      },
      openAppModal (type) {
        console.log('openAppModal', type)
        this.$emit('openAppModal', type)
      },
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.showAlertMessage(null)
        this.$refs.modal.close()
      },
      checkCloseLoginModal () {
        this.showAlertMessage(null)
        if (this.$route.path === '/booking/choose-cleaner' && this.user === null) {
          this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/LoginModal.vue